/** The numeric `id` of what a create call returned, or null when it gave none. */
export function idOf(created) {
    if (created && typeof created === 'object' && 'id' in created) {
        const id = created.id;
        return typeof id === 'number' ? id : null;
    }
    return null;
}
